module.exports = __webpack_public_path__ + "static/media/user.0c039611.svg";